import { forwardRef, type SelectHTMLAttributes } from "react";
import { inputClass } from "./input";
import { cn } from "@/lib/utils";

/** Native select styled with the brand tokens (keyboard and screen-reader friendly by default). */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => (
    <select ref={ref} className={cn(inputClass, "w-auto cursor-pointer pr-10", className)} {...props} />
  ),
);
Select.displayName = "Select";
